import React from 'react';

import { ContainerSC } from './StyledComponents';

interface ParentContainerProps {
  children: React.ReactNode | React.ReactNode[];
  [key: string]: React.ReactNode;
}

export const ParentContainer = ({
  children,
  ...rest
}: ParentContainerProps): React.ReactElement => {
  return <ContainerSC {...rest}>{children}</ContainerSC>;
};
